import * as Inovx from '@shared';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/OrganizationApi/api/Role`;

const RoleServices = {
    ...Inovx.Shared.Flux.BaseService,
    getAll: function () {
        return new Promise<IOrganizationRole[]>((resolve, reject) => {
            this.get(
                url,
                null,
                (retData: IOrganizationRole[]) => {
                    resolve(retData || []);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    }
};

export default RoleServices;